import { createTRPCReact } from '@trpc/react-query';
import { type AppRouter } from 'jigsaw';
import { createTRPCProxyClient, httpBatchLink } from '@trpc/client';
import superjson from 'superjson';

const batchLink = httpBatchLink({
  url: `${import.meta.env.VITE_JIGSAW_URL}`,
  /// to support session cookies
  fetch(url, options) {
    return fetch(url, {
      ...options,
      credentials: 'include',
    });
  },
  maxURLLength: 10_000,
});

// tRPC for react usage
export const trpcReact = createTRPCReact<AppRouter>();

export const trpcClient = trpcReact.createClient({
  links: [batchLink],
  transformer: superjson,
});

// tRPC for non-react usage
export const trpc = createTRPCProxyClient<AppRouter>({
  links: [batchLink],
  transformer: superjson,
});
